import { render, staticRenderFns } from "./CustomerSetting.vue?vue&type=template&id=265fba73&scoped=true&lang=pug&"
import script from "./CustomerSetting.vue?vue&type=script&lang=js&"
export * from "./CustomerSetting.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSetting.vue?vue&type=style&index=0&id=265fba73&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265fba73",
  null
  
)

export default component.exports